/*!
 * muckissteine – Wunschliste
 * Speichert gemerkte Produkte im Browser (localStorage), fügt Herz-Buttons auf
 * Produktkarten und Produktseiten sowie ein Header-Icon ein und rendert die
 * Wunschlisten-Seite. Optional: Events an Klaviyo.
 * Konfiguration kommt aus der Section "Wunschliste" (sections/muckis-wishlist-core.liquid).
 */
(function () {
  'use strict';

  if (window.MuckisWishlist) return;

  var cfgEl = document.getElementById('muckis-wishlist-config');
  if (!cfgEl) return;

  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }

  var KEY = CFG.storageKey || 'muckis-wishlist-v1';
  var MAX_ITEMS = 100;
  var MAX_SHARED = 50;

  var S = Object.assign(
    {
      add: 'Auf die Wunschliste',
      added: 'Auf der Wunschliste',
      remove: 'Von der Wunschliste entfernen',
      toastAdded: 'Zur Wunschliste hinzugefügt',
      toastRemoved: 'Von der Wunschliste entfernt',
      toastView: 'Ansehen',
      headerLabel: 'Wunschliste',
      addToCart: 'In den Warenkorb',
      chooseOptions: 'Optionen wählen',
      viewProduct: 'Zum Produkt',
      inStock: 'Verfügbar',
      outOfStock: 'Derzeit nicht verfügbar',
      sale: 'Angebot',
      priceDrop: 'Preis gesunken',
      priceDropNote: '{{ amount }} günstiger als beim Merken',
      itemsOne: '1 Artikel',
      itemsMany: '{{ count }} Artikel',
      cartAdded: 'In den Warenkorb gelegt',
      cartAllAdded: '{{ count }} Artikel in den Warenkorb gelegt',
      cartError: 'Konnte nicht in den Warenkorb gelegt werden.',
      shareTitle: 'Meine Wunschliste bei Muckis Steine',
      shareCopied: 'Link zur Wunschliste kopiert',
      shareFallback: 'Link zum Teilen:',
      sharedSaved: 'Auf deine Wunschliste übernommen',
      sharedHeading: 'Geteilte Wunschliste',
      loadError: 'Die Wunschliste konnte gerade nicht geladen werden. Bitte lade die Seite neu.'
    },
    CFG.strings || {}
  );

  /* ------------------------------------------------------------------ *
   * Hilfsfunktionen
   * ------------------------------------------------------------------ */

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function tpl(str, vars) {
    return String(str).replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      return vars && vars[k] != null ? vars[k] : '';
    });
  }

  function normHandle(handle) {
    var h = String(handle || '');
    try {
      h = decodeURIComponent(h);
    } catch (e) {}
    return h.trim().toLowerCase();
  }

  function handleFromUrl(url) {
    if (!url) return null;
    var clean = String(url).split('?')[0].split('#')[0];
    var m = clean.match(/\/products\/([^\/]+)/);
    return m ? normHandle(m[1]) : null;
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function absUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }

  function sizedImage(url, width) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + width);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function formatNumber(n, decimals, thousands, decimal) {
    var fixed = Number(n).toFixed(decimals);
    var parts = fixed.split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? int + decimal + parts[1] : int;
  }

  function formatMoney(cents) {
    var value = (Number(cents) || 0) / 100;
    var active = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;

    if (active && CFG.shopCurrency && active !== CFG.shopCurrency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency',
          currency: active
        }).format(value);
      } catch (e) {}
    }

    var fmt = CFG.moneyFormat || '€{{amount_with_comma_separator}}';
    var pattern = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(pattern);
    var out;

    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        out = formatNumber(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        out = formatNumber(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = formatNumber(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        out = formatNumber(value, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        out = formatNumber(value, 2, ' ', ',');
        break;
      default:
        out = formatNumber(value, 2, ',', '.');
    }
    return fmt.replace(pattern, out);
  }

  var HEART_PATH =
    'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z';

  function heartSvg(extraClass, size) {
    var s = size || 18;
    return (
      '<svg class="mwl-heart' + (extraClass ? ' ' + extraClass : '') + '" width="' + s + '" height="' + s +
      '" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + HEART_PATH + '"/></svg>'
    );
  }

  var CLOSE_SVG =
    '<svg class="mwl-close" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  /* ------------------------------------------------------------------ *
   * Speicher
   * ------------------------------------------------------------------ */

  var memoryStore = [];

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      return list.filter(function (i) {
        return i && typeof i.h === 'string' && i.h;
      });
    } catch (e) {
      return memoryStore.slice();
    }
  }

  function write(items, silent) {
    memoryStore = items.slice();
    try {
      window.localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {}
    if (!silent) notify('local');
  }

  var listeners = [];

  function notify(source) {
    var items = read();
    listeners.forEach(function (fn) {
      try {
        fn(items, source);
      } catch (e) {}
    });
    try {
      document.dispatchEvent(new CustomEvent('muckis:wishlist:change', { detail: { items: items, source: source } }));
    } catch (e) {}
  }

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) notify('storage');
  });

  function has(handle) {
    var h = normHandle(handle);
    return read().some(function (i) {
      return i.h === h;
    });
  }

  function addItem(product, opts) {
    var h = normHandle(product.handle);
    if (!h) return;
    var items = read().filter(function (i) {
      return i.h !== h;
    });
    items.unshift({
      h: h,
      id: product.id || null,
      p: typeof product.price === 'number' ? product.price : null,
      t: Date.now()
    });
    write(items.slice(0, MAX_ITEMS));
    if (!(opts && opts.silent)) track('Added to Wishlist', product);
  }

  function removeItem(handle, opts) {
    var h = normHandle(handle);
    var removed = null;
    var items = read().filter(function (i) {
      if (i.h === h) {
        removed = i;
        return false;
      }
      return true;
    });
    write(items);
    if (removed && !(opts && opts.silent)) {
      var cached = productCacheValue(h);
      track('Removed from Wishlist', cached || { handle: h, id: removed.id });
    }
  }

  /* ------------------------------------------------------------------ *
   * Produktdaten (Storefront-Endpunkt /products/<handle>.js)
   * ------------------------------------------------------------------ */

  var productCache = {};
  var productValues = {};

  function productCacheValue(h) {
    return productValues[h] || null;
  }

  if (CFG.product && CFG.product.handle) {
    productValues[normHandle(CFG.product.handle)] = CFG.product;
  }

  function fetchProduct(handle) {
    var h = normHandle(handle);
    if (productValues[h]) return Promise.resolve(productValues[h]);
    if (!productCache[h]) {
      var url = rootUrl() + 'products/' + encodeURIComponent(h) + '.js';
      productCache[h] = fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (res) {
          if (res.status === 404) return null;
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (p) {
          if (p) productValues[h] = p;
          return p;
        })
        .catch(function (err) {
          delete productCache[h];
          throw err;
        });
    }
    return productCache[h];
  }

  function fetchMany(handles, concurrency) {
    var results = new Array(handles.length);
    var index = 0;
    var limit = concurrency || 6;

    function worker() {
      if (index >= handles.length) return Promise.resolve();
      var i = index++;
      return fetchProduct(handles[i])
        .then(
          function (p) {
            results[i] = { h: handles[i], p: p };
          },
          function () {
            results[i] = { h: handles[i], p: undefined, error: true };
          }
        )
        .then(worker);
    }

    var workers = [];
    for (var w = 0; w < Math.min(limit, handles.length); w++) workers.push(worker());
    return Promise.all(workers).then(function () {
      return results;
    });
  }

  /* ------------------------------------------------------------------ *
   * Klaviyo
   * ------------------------------------------------------------------ */

  var klaviyoIdentified = false;

  function klaviyoPush(args) {
    if (window.klaviyo && typeof window.klaviyo.push === 'function') {
      window.klaviyo.push(args);
    } else {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(args);
    }
  }

  function track(eventName, p) {
    if (!CFG.klaviyo || !p) return;
    try {
      if (CFG.customerEmail && !klaviyoIdentified) {
        klaviyoPush(['identify', { email: CFG.customerEmail }]);
        klaviyoIdentified = true;
      }
      var props = {
        ProductName: p.title || null,
        ProductID: p.id || null,
        Handle: p.handle || null,
        URL: p.url ? absUrl(p.url.split('?')[0]) : p.handle ? window.location.origin + rootUrl() + 'products/' + p.handle : null,
        ImageURL: p.featured_image ? absUrl(sizedImage(p.featured_image, 600)) : null,
        Price: typeof p.price === 'number' ? p.price / 100 : null,
        CompareAtPrice: p.compare_at_price ? p.compare_at_price / 100 : null,
        Brand: p.vendor || null,
        Categories: p.type ? [p.type] : [],
        Source: 'Wunschliste',
        WishlistCount: read().length
      };
      klaviyoPush(['track', eventName, props]);
    } catch (e) {}
  }

  /* ------------------------------------------------------------------ *
   * Toast
   * ------------------------------------------------------------------ */

  var toastEl = null;
  var toastTimer = null;

  function toast(message, withLink, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'mwl-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    var link = withLink && !pageRoot ? ' <a href="' + esc(CFG.pageUrl) + '">' + esc(S.toastView) + '</a>' : '';
    toastEl.innerHTML = '<span>' + esc(message) + '</span>' + link;
    toastEl.classList.toggle('is-error', !!isError);
    // Reflow, damit die Einblend-Animation erneut startet
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 3200);
  }

  /* ------------------------------------------------------------------ *
   * Toggle-Buttons (Karten, Produktseite, geteilte Liste)
   * ------------------------------------------------------------------ */

  function syncButtons(items) {
    var list = items || read();
    var set = {};
    list.forEach(function (i) {
      set[i.h] = true;
    });

    document.querySelectorAll('[data-mwl-toggle]').forEach(function (btn) {
      var active = !!set[btn.getAttribute('data-handle')];
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = active ? S.added : S.add;
      if (btn.hasAttribute('data-mwl-labelled')) {
        var span = btn.querySelector('[data-mwl-label]');
        // Nur bei Änderung schreiben – sonst löst der MutationObserver eine Endlosschleife aus
        if (span && span.textContent !== label) span.textContent = label;
      } else if (btn.getAttribute('aria-label') !== label) {
        btn.setAttribute('aria-label', label);
        btn.setAttribute('title', label);
      }
    });

    var count = list.length;
    var countLabel = count > 99 ? '99+' : String(count);
    document.querySelectorAll('[data-mwl-count]').forEach(function (el) {
      if (el.textContent !== countLabel) el.textContent = countLabel;
      if (el.hidden !== (count === 0)) el.hidden = count === 0;
    });
    document.querySelectorAll('.mwl-header-link').forEach(function (a) {
      a.classList.toggle('has-items', count > 0);
      a.setAttribute('aria-label', S.headerLabel + (count ? ' (' + count + ')' : ''));
    });
  }

  function pop(btn) {
    var svg = btn.querySelector('.mwl-heart');
    if (!svg) return;
    svg.classList.remove('mwl-pop');
    void svg.getBoundingClientRect();
    svg.classList.add('mwl-pop');
  }

  function onToggleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = e.currentTarget;
    var h = btn.getAttribute('data-handle');
    if (!h || btn.classList.contains('is-busy')) return;

    if (has(h)) {
      removeItem(h);
      toast(S.toastRemoved, false);
      return;
    }

    btn.classList.add('is-busy');
    fetchProduct(h)
      .catch(function () {
        return null;
      })
      .then(function (p) {
        addItem(p || { handle: h });
        btn.classList.remove('is-busy');
        pop(btn);
        toast(S.toastAdded, true);
      });
  }

  function makeToggle(handle, variant) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('data-mwl-toggle', '');
    btn.setAttribute('data-handle', handle);
    btn.setAttribute('aria-pressed', 'false');

    if (variant === 'product') {
      btn.className = 'mwl-product-btn';
      btn.setAttribute('data-mwl-labelled', '');
      btn.innerHTML = heartSvg('', 18) + '<span data-mwl-label>' + esc(S.add) + '</span>';
    } else {
      btn.className = 'mwl-card-btn';
      btn.innerHTML = heartSvg('', 18);
    }
    btn.addEventListener('click', onToggleClick);
    return btn;
  }

  /* ------------------------------------------------------------------ *
   * Einbau: Header, Produktkarten, Produktseite
   * ------------------------------------------------------------------ */

  function headerLink(mobile) {
    var a = document.createElement('a');
    a.href = CFG.pageUrl;
    a.className = 'mwl-header-link standalone-icon--wrapper' + (mobile ? ' site-nav__link mwl-header-link--mobile' : '');
    a.setAttribute('aria-label', S.headerLabel);
    var icon = heartSvg(mobile ? 'fa-2x' : '', 20);
    var bubble = '<span class="mwl-count" data-mwl-count hidden>0</span>';
    a.innerHTML = mobile
      ? '<span class="icon-fallback-text">' + icon + bubble + '<span class="fallback-text">' + esc(S.headerLabel) + '</span></span>'
      : icon + bubble;
    return a;
  }

  function injectHeader() {
    if (!CFG.headerIcon) return;

    document.querySelectorAll('.site-header__links.top-links--icon-links').forEach(function (ul) {
      if (ul.querySelector('.mwl-header-link')) return;
      var cartLi = null;
      Array.prototype.forEach.call(ul.children, function (li) {
        if (!cartLi && li.querySelector('a[href$="/cart"], .site-header__cart-toggle')) cartLi = li;
      });
      var li = document.createElement('li');
      li.className = 'mwl-header-item';
      li.appendChild(headerLink(false));
      ul.insertBefore(li, cartLi);
    });

    document.querySelectorAll('.site-nav--mobile').forEach(function (nav) {
      if (nav.querySelector('.mwl-header-link')) return;
      var cart = nav.querySelector('a[href$="/cart"]');
      if (!cart) return;
      nav.insertBefore(headerLink(true), cart);
    });
  }

  function injectCards() {
    if (!CFG.cards) return;
    var cards = document.querySelectorAll('product-card.grid-view-item, .grid-view-item[data-product-url]');
    cards.forEach(function (card) {
      // Prüft das Kind-Element statt eines Markers, falls das Theme die Karte neu rendert
      for (var c = 0; c < card.children.length; c++) {
        if (card.children[c].classList.contains('mwl-card-btn')) return;
      }
      var link = card.querySelector('a[href*="/products/"]');
      var handle = handleFromUrl(card.getAttribute('data-product-url') || (link && link.getAttribute('href')));
      if (!handle) return;
      if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
      card.appendChild(makeToggle(handle, 'card'));
    });
  }

  function findProductFormAnchor() {
    var ids = (CFG.product.variant_ids || []).map(String);
    var skip = 'cart-drawer, #CartDrawer, [id*="QuickView"], [class*="quick-view"], .shopify-payment-terms__container, [data-mwl-page]';

    function matches(el) {
      if (el.closest(skip)) return false;
      var input = el.querySelector('input[name="id"], select[name="id"]');
      var value = input && input.value != null ? String(input.value) : '';
      return !!value && ids.indexOf(value) > -1;
    }

    // 1. Das Produktformular des Themes (enthält den Warenkorb-Button)
    var els = document.querySelectorAll('product-form');
    for (var i = 0; i < els.length; i++) {
      if (matches(els[i])) return els[i];
    }

    // 2. Fallback: irgendein Warenkorb-Formular für dieses Produkt
    els = document.querySelectorAll('form[action*="/cart/add"]');
    for (var j = 0; j < els.length; j++) {
      if (matches(els[j])) return els[j].closest('product-form') || els[j];
    }

    return document.querySelector('.product-form-block');
  }

  function injectProductButton() {
    if (!CFG.productPage || !CFG.product || !CFG.product.handle) return;
    var handle = normHandle(CFG.product.handle);
    if (document.querySelector('.mwl-product [data-handle="' + handle.replace(/"/g, '\\"') + '"]')) return;
    var anchor = findProductFormAnchor();
    if (!anchor) return;
    var wrap = document.createElement('div');
    wrap.className = 'mwl-product';
    wrap.appendChild(makeToggle(handle, 'product'));
    anchor.insertAdjacentElement('afterend', wrap);
  }

  function injectAll() {
    try {
      injectHeader();
    } catch (e) {}
    try {
      injectCards();
    } catch (e) {}
    try {
      injectProductButton();
    } catch (e) {}
    syncButtons();
  }

  var injectQueued = false;
  function queueInject() {
    if (injectQueued) return;
    injectQueued = true;
    setTimeout(function () {
      injectQueued = false;
      injectAll();
    }, 120);
  }

  /* ------------------------------------------------------------------ *
   * Warenkorb (nutzt die Cart-Drawer-Events des Flow-Themes)
   * ------------------------------------------------------------------ */

  function addToCart(items) {
    var addUrl = ((window.routes && window.routes.cart_add_url) || rootUrl() + 'cart/add') + '.js';
    return fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items, sections: 'cart-drawer' })
    })
      .then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok || (json && json.status && Number(json.status) >= 400)) {
            var err = new Error((json && (json.description || json.message)) || S.cartError);
            err.json = json;
            throw err;
          }
          return json;
        });
      })
      .then(function (json) {
        afterCartChange(json);
        return json;
      });
  }

  function afterCartChange(json) {
    try {
      if (window.eventBus && json && json.sections) window.eventBus.emit('update:cart:drawer', json);
    } catch (e) {}

    var cartUrl = (window.routes && window.routes.cart_url) || rootUrl() + 'cart';
    fetch(cartUrl + '?view=compare', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(cart);
      })
      .catch(function () {});
  }

  function openCart() {
    var cartUrl = (window.routes && window.routes.cart_url) || rootUrl() + 'cart';
    if (window.eventBus && document.querySelector('cart-drawer')) {
      window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
    } else {
      window.location.href = cartUrl;
    }
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.classList.toggle('is-loading', busy);
    btn.disabled = busy;
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  /* ------------------------------------------------------------------ *
   * Wunschlisten-Seite
   * ------------------------------------------------------------------ */

  var pageRoot = null;
  var pageMode = 'own';
  var sharedHandles = [];
  var renderedProducts = [];
  var renderToken = 0;
  var skipNextRender = false;

  function variantInfo(p) {
    var variants = p.variants || [];
    var single = variants.length <= 1;
    var firstAvailable = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) {
        firstAvailable = variants[i];
        break;
      }
    }
    return { single: single, variant: single ? variants[0] : firstAvailable, available: !!p.available };
  }

  function itemHTML(p, saved) {
    var h = normHandle(p.handle);
    var url = p.url || rootUrl() + 'products/' + p.handle;
    var img = p.featured_image ? sizedImage(p.featured_image, 500) : '';
    var info = variantInfo(p);
    var price = typeof p.price === 'number' ? p.price : 0;
    var compare = p.compare_at_price && p.compare_at_price > price ? p.compare_at_price : 0;
    var savedPrice = saved && typeof saved.p === 'number' ? saved.p : null;
    var dropped = savedPrice != null && price < savedPrice;

    var badge = '';
    if (dropped) badge = '<span class="mwl-badge mwl-badge--drop">' + esc(S.priceDrop) + '</span>';
    else if (compare) badge = '<span class="mwl-badge mwl-badge--sale">' + esc(S.sale) + '</span>';

    var corner =
      pageMode === 'own'
        ? '<button type="button" class="mwl-card-btn mwl-item__remove" data-mwl-remove data-handle="' + esc(h) + '" aria-label="' + esc(S.remove) + '" title="' + esc(S.remove) + '">' + CLOSE_SVG + '</button>'
        : '';

    var action;
    if (info.available && info.single && info.variant) {
      action = '<button type="button" class="btn mwl-item__atc" data-mwl-atc data-variant="' + esc(info.variant.id) + '">' + esc(S.addToCart) + '</button>';
    } else if (info.available) {
      action = '<a class="btn mwl-item__atc" href="' + esc(url) + '">' + esc(S.chooseOptions) + '</a>';
    } else {
      action = '<a class="btn mwl-btn-secondary mwl-item__atc" href="' + esc(url) + '">' + esc(S.viewProduct) + '</a>';
    }

    return (
      '<article class="mwl-item" data-handle="' + esc(h) + '">' +
      '<div class="mwl-item__media-wrap">' +
      '<a class="mwl-item__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
      (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="500" height="500">' : '') +
      '</a>' +
      badge +
      corner +
      '</div>' +
      '<div class="mwl-item__info">' +
      '<a class="mwl-item__title" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
      '<div class="mwl-item__price"><span class="money">' + formatMoney(price) + '</span>' +
      (compare ? '<s class="money">' + formatMoney(compare) + '</s>' : '') +
      '</div>' +
      (dropped ? '<div class="mwl-item__drop">' + esc(tpl(S.priceDropNote, { amount: formatMoney(savedPrice - price) })) + '</div>' : '') +
      '<div class="mwl-item__stock ' + (info.available ? 'is-in' : 'is-out') + '">' + esc(info.available ? S.inStock : S.outOfStock) + '</div>' +
      '<div class="mwl-item__actions">' + action + '</div>' +
      '</div>' +
      '</article>'
    );
  }

  function countText(n) {
    return n === 1 ? S.itemsOne : tpl(S.itemsMany, { count: n });
  }

  function setPageState(state) {
    var loading = pageRoot.querySelector('[data-mwl-loading]');
    var empty = pageRoot.querySelector('[data-mwl-empty]');
    var toolbar = pageRoot.querySelector('[data-mwl-toolbar]');
    var error = pageRoot.querySelector('[data-mwl-error]');
    if (loading) loading.hidden = state !== 'loading';
    if (empty) empty.hidden = state !== 'empty';
    if (toolbar) toolbar.hidden = state !== 'list';
    if (error) error.hidden = state !== 'error';
  }

  function updateToolbar() {
    var n = renderedProducts.length;
    var countEl = pageRoot.querySelector('[data-mwl-count-text]');
    if (countEl) countEl.textContent = countText(n);

    var addAll = pageRoot.querySelector('[data-mwl-add-all]');
    if (addAll) {
      var addable = renderedProducts.filter(function (p) {
        var info = variantInfo(p);
        return info.available && info.single && info.variant;
      });
      addAll.hidden = addable.length < 2;
    }
    if (n === 0) setPageState('empty');
  }

  function renderPage() {
    if (!pageRoot) return;
    var token = ++renderToken;
    var grid = pageRoot.querySelector('[data-mwl-grid]');
    var savedMap = {};
    var handles;

    if (pageMode === 'shared') {
      handles = sharedHandles;
    } else {
      var items = read();
      items.forEach(function (i) {
        savedMap[i.h] = i;
      });
      handles = items.map(function (i) {
        return i.h;
      });
    }

    if (!handles.length) {
      grid.innerHTML = '';
      renderedProducts = [];
      setPageState('empty');
      return;
    }

    if (!grid.children.length) setPageState('loading');

    fetchMany(handles, 6).then(function (results) {
      if (token !== renderToken) return;

      var failed = results.filter(function (r) {
        return r.error;
      });
      if (failed.length === results.length) {
        setPageState('error');
        return;
      }

      // Produkte, die es nicht mehr gibt (404), still aus der eigenen Liste entfernen
      if (pageMode === 'own') {
        var gone = results
          .filter(function (r) {
            return r.p === null;
          })
          .map(function (r) {
            return r.h;
          });
        if (gone.length) {
          write(
            read().filter(function (i) {
              return gone.indexOf(i.h) === -1;
            }),
            true
          );
          syncButtons();
        }
      }

      renderedProducts = results
        .filter(function (r) {
          return r.p;
        })
        .map(function (r) {
          return r.p;
        });

      grid.innerHTML = renderedProducts
        .map(function (p) {
          return itemHTML(p, savedMap[normHandle(p.handle)]);
        })
        .join('');

      if (pageMode === 'shared') {
        grid.querySelectorAll('.mwl-item__media-wrap').forEach(function (wrap) {
          var h = wrap.parentElement.getAttribute('data-handle');
          wrap.appendChild(makeToggle(h, 'card'));
        });
      }

      if (!renderedProducts.length) {
        setPageState('empty');
        return;
      }
      setPageState('list');
      updateToolbar();
      syncButtons();
    });
  }

  function removeFromPage(btn) {
    var h = btn.getAttribute('data-handle');
    var card = btn.closest('.mwl-item');
    skipNextRender = true;
    removeItem(h);
    renderedProducts = renderedProducts.filter(function (p) {
      return normHandle(p.handle) !== h;
    });
    if (card) {
      card.classList.add('is-removing');
      setTimeout(function () {
        if (card.parentNode) card.parentNode.removeChild(card);
        updateToolbar();
      }, 220);
    } else {
      updateToolbar();
    }
  }

  function addOneToCart(btn) {
    var id = Number(btn.getAttribute('data-variant'));
    if (!id) return;
    setBusy(btn, true);
    addToCart([{ id: id, quantity: 1 }])
      .then(function () {
        setBusy(btn, false);
        openCart();
      })
      .catch(function (err) {
        setBusy(btn, false);
        toast(err && err.message ? err.message : S.cartError, false, true);
      });
  }

  function addAllToCart(btn) {
    var items = [];
    renderedProducts.forEach(function (p) {
      var info = variantInfo(p);
      if (info.available && info.single && info.variant) items.push({ id: info.variant.id, quantity: 1 });
    });
    if (!items.length) return;

    setBusy(btn, true);
    addToCart(items)
      .then(function () {
        setBusy(btn, false);
        toast(tpl(S.cartAllAdded, { count: items.length }));
        openCart();
      })
      .catch(function () {
        // Fallback: einzeln hinzufügen, damit ein ausverkaufter Artikel nicht alles blockiert
        var added = 0;
        var chain = Promise.resolve();
        items.forEach(function (item) {
          chain = chain.then(function () {
            return addToCart([item]).then(
              function () {
                added++;
              },
              function () {}
            );
          });
        });
        chain.then(function () {
          setBusy(btn, false);
          if (added) {
            toast(tpl(S.cartAllAdded, { count: added }));
            openCart();
          } else {
            toast(S.cartError, false, true);
          }
        });
      });
  }

  function shareList(btn) {
    var handles = read()
      .map(function (i) {
        return i.h;
      })
      .slice(0, MAX_SHARED);
    if (!handles.length) return;
    var url = window.location.origin + CFG.pageUrl + '?liste=' + encodeURIComponent(handles.join(','));

    if (navigator.share) {
      navigator.share({ title: S.shareTitle, url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(
        function () {
          toast(S.shareCopied);
        },
        function () {
          window.prompt(S.shareFallback, url);
        }
      );
      return;
    }
    window.prompt(S.shareFallback, url);
  }

  function saveSharedToOwn(btn) {
    var own = read();
    var ownSet = {};
    own.forEach(function (i) {
      ownSet[i.h] = true;
    });
    var added = 0;
    renderedProducts
      .slice()
      .reverse()
      .forEach(function (p) {
        var h = normHandle(p.handle);
        if (!ownSet[h]) {
          addItem(p);
          added++;
        }
      });
    if (btn) btn.disabled = true;
    toast(S.sharedSaved, false);
    if (!added) syncButtons();
  }

  function initPage() {
    pageRoot = document.querySelector('[data-mwl-page]');
    if (!pageRoot) return;

    var params = new URLSearchParams(window.location.search);
    var shared = params.get('liste');
    if (shared) {
      var seen = {};
      sharedHandles = shared
        .split(',')
        .map(normHandle)
        .filter(function (h) {
          if (!h || seen[h]) return false;
          seen[h] = true;
          return true;
        })
        .slice(0, MAX_SHARED);
      if (sharedHandles.length) pageMode = 'shared';
    }

    pageRoot.classList.toggle('is-shared', pageMode === 'shared');
    if (pageMode === 'shared') {
      var scope = pageRoot.closest('.width--content') || document;
      var title = scope.querySelector('h1');
      if (title) title.textContent = S.sharedHeading;
    }
    var banner = pageRoot.querySelector('[data-mwl-shared-banner]');
    if (banner) banner.hidden = pageMode !== 'shared';
    pageRoot.querySelectorAll('[data-mwl-own-only]').forEach(function (el) {
      el.hidden = pageMode === 'shared';
    });

    pageRoot.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-mwl-remove]');
      if (removeBtn) {
        e.preventDefault();
        removeFromPage(removeBtn);
        return;
      }
      var atc = e.target.closest('[data-mwl-atc][data-variant]');
      if (atc) {
        e.preventDefault();
        addOneToCart(atc);
        return;
      }
      var addAll = e.target.closest('[data-mwl-add-all]');
      if (addAll) {
        e.preventDefault();
        addAllToCart(addAll);
        return;
      }
      var share = e.target.closest('[data-mwl-share]');
      if (share) {
        e.preventDefault();
        shareList(share);
        return;
      }
      var saveShared = e.target.closest('[data-mwl-save-shared]');
      if (saveShared) {
        e.preventDefault();
        saveSharedToOwn(saveShared);
      }
    });

    listeners.push(function () {
      if (pageMode !== 'own') return;
      if (skipNextRender) {
        skipNextRender = false;
        return;
      }
      renderPage();
    });

    renderPage();
  }

  /* ------------------------------------------------------------------ *
   * Start
   * ------------------------------------------------------------------ */

  listeners.push(function (items) {
    syncButtons(items);
  });

  function start() {
    initPage();
    injectAll();

    if (window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            queueInject();
            return;
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', queueInject);
  }

  window.MuckisWishlist = {
    items: read,
    count: function () {
      return read().length;
    },
    has: has,
    add: function (handle) {
      return fetchProduct(handle)
        .catch(function () {
          return null;
        })
        .then(function (p) {
          addItem(p || { handle: handle });
        });
    },
    remove: removeItem,
    refresh: injectAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
